export default __webpack_public_path__ + "static/media/NewLockIcon.20842bae.png";